import React from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"

const UserComponent = (props: any) => {
  const [t] = useTranslation("global")
  const isModal = typeof props.show === "boolean"

  return (
    <CRUD
      cssClass="modalRight"
      isModal={isModal}
      showModal={props.show ?? false}
      toggleCRUD={props.toggle}
      title={t("users") ?? ""}
      getRecordsPath="users/list"
      addEditRecordPath="users/AddEditUser"
      deleteRecordPath="users/Delete"
      fieldsList={[
        {
          name: "firstName",
          title: t("firstName"),
        },
        {
          name: "lastName",
          title: t("lastName"),
        },
        {
          name: "email",
          title: t("email"),
        },
        {
          name: "roleName",
          title: t("role"),
        },
      ]}
      fields={[
        {
          name: "id",
          htmlType: "hidden",
          dbType: "string",
        },
        {
          name: "firstName",
          htmlType: "text",
          dbType: "string",
          title: t("firstName") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },
        {
          name: "lastName",
          htmlType: "text",
          dbType: "string",
          title: t("lastName") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },
        {
          name: "email",
          htmlType: "email",
          dbType: "string",
          title: t("email") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },

        {
          name: "password",
          htmlType: "password",
          dbType: "string",
          title: t("password") ?? "",
          containerClass: "col-12 col-md-6",
          required: false,
          requiredOnCreate: true,
          minLength: 6,
        },

        {
          name: "roleId",
          htmlType: "select",
          dbType: "string",
          title: t("role") ?? "",
          containerClass: "col-12 col-md-6",
          dataSource: "users/roles",
          dataSourceTextField: "name",
          dataSourceValueField: "id",
          required: true,
        },
      ]}
    />
  )
}

export default UserComponent
